<template>
  <div>
    <div class="container pt-0">
      <div class="row" ref="topZusammenfassung">
        <div class="col-12">
          <div class="pane">
            <overlay ref="terminBereitsVergebenAlert">
              <div class="text-center">
                <div class="font-weight-bold fs-14 mb-3">
                  {{ $t("error.termin_bereits_vergeben") }}
                </div>
                <button
                  class="btn btn-primary"
                  @click="zurTerminwahl"
                >
                  {{ $t("zur_terminwahl") }}
                  <font-awesome-icon icon="arrow-right" />
                </button>
              </div>
            </overlay>
            <overlay ref="kreditunwuerdigAlert">
              <div class="text-center">
                <div class="font-weight-bold fs-14 mb-3">
                  <p v-html="$t('error.kreditunwuerdig')" />
                </div>
                <button
                  class="btn btn-primary"
                  @click="$refs.kreditunwuerdigAlert.hide()"
                >
                  {{ $t("actions.close") }}
                  <font-awesome-icon icon="arrow-right" />
                </button>
              </div>
            </overlay>
            <div class="row">
              <div
                class="col-md-5 pr-lg-5 text-left"
                :class="{ 'border-right': !isMobile }"
              >
                <div class="row">
                  <div class="col-10">
                    <h2>{{ $t("desired_appointment") }}</h2>
                  </div>
                  <div class="col-2 text-right">
                    <font-awesome-icon
                      style="cursor: pointer"
                      icon="pencil-alt"
                      @click="unselectTermin"
                    />
                  </div>
                </div>
                <termin-zusammenfassung />
              </div>
              <div class="col-md-7 pl-lg-5 mt-5 mt-lg-0">
                <h2>{{ $t("head_patient_data") }}</h2>
                <div v-if="patient_final" class="mb-3 text-dark">
                  {{ $t("patientendaten.bereits_erfasst") }}
                </div>
                <div v-if="!patient_final" class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t("anrede") }}</label>
                      <button-switch
                        class="btn-switcher"
                        :values="[
                          { title: $t('anrede_herr'), value: '14503998EE6' },
                          { title: $t('anrede_frau'), value: '1450399A75E' },
                        ]"
                        :reduce="(e) => e.value"
                        button-class="bg-medium-gray"
                        :class="{
                          'is-invalid border border-danger rounded':
                            !anrede && hasError,
                        }"
                        v-model="anrede"
                      ></button-switch>
                      <div v-if="!anrede && hasError" class="invalid-feedback">
                        {{ $t("error.anrede") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!patient_final" class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="input-vorname">{{ $t("prename") }}</label>
                      <input
                        id="input-vorname"
                        name="firstname"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !vorname && hasError }"
                        v-model="vorname"
                      />
                      <div
                        v-if="(!vorname || vorname === '') && hasError"
                        class="invalid-feedback"
                      >
                        {{ $t("error.prename") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="input-name">{{ $t("name") }}</label>
                      <input
                        id="input-name"
                        name="lastname"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !name && hasError }"
                        v-model="name"
                      />
                      <div v-if="!name && hasError" class="invalid-feedback">
                        {{ $t("error.name") }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!patient_final" class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="input-geburtsdatum">{{
                        $t("birthday")
                      }}</label>
                      <input
                        v-if="!showDateTextInput"
                        id="input-geburtsdatum"
                        name="birthdate"
                        type="date"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            (!geburtsdatum || invalidGeburtstag) && hasError,
                        }"
                        v-model="geburtsdatum"
                        placeholder="TT.MM.YYYY"
                      />
                      <div
                        class="input-group col-md-8 px-0"
                        v-if="showDateTextInput"
                      >
                        <input
                          class="form-control col-3"
                          placeholder="tt"
                          v-model.number="tag"
                          min="1"
                          max="31"
                          type="number"
                          :class="{
                            'is-invalid':
                              (!geburtsdatum || invalidGeburtstag) && hasError,
                          }"
                        />
                        <input
                          class="form-control col-3"
                          placeholder="mm"
                          v-model.number="monat"
                          min="1"
                          max="12"
                          type="number"
                          :class="{
                            'is-invalid':
                              (!geburtsdatum || invalidGeburtstag) && hasError,
                          }"
                        />
                        <input
                          class="form-control col-6"
                          placeholder="yyyy"
                          v-model.number="jahr"
                          min="1900"
                          type="number"
                          :class="{
                            'is-invalid':
                              (!geburtsdatum || invalidGeburtstag) && hasError,
                          }"
                        />
                      </div>
                      <div
                        v-if="!geburtsdatum && hasError"
                        class="invalid-feedback"
                      >
                        {{ $t("error.geburtstag") }}
                      </div>
                      <div
                        v-if="invalidGeburtstag && hasError"
                        class="invalid-feedback"
                      >
                        {{ $t("error.geburtstag_invalid") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!patient_final" class="row">
                  <div class="col-md-9">
                    <div class="form-group">
                      <label
                        for="input-strasse"
                        v-html="$t('strasse')"
                      ></label>
                      <input
                        id="input-strasse"
                        name="strasse"
                        type="text"
                        class="form-control"
                        v-model="adr_strasse"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="input-hausnummer">{{
                        $t("hausnummer")
                      }}</label>
                      <input
                        id="input-hausnummer"
                        name="hausnummer"
                        type="text"
                        class="form-control"
                        v-model="adr_strassenr"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="!patient_final" class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label
                        for="input-plz"
                        v-html="$t('plz')"
                      ></label>
                      <input
                        id="input-plz"
                        name="plz"
                        type="text"
                        class="form-control"
                        v-model="adr_plz"
                      />
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group">
                      <label for="input-ort">{{
                        $t("ort")
                      }}</label>
                      <input
                        id="input-ort"
                        name="ort"
                        type="text"
                        class="form-control"
                        v-model="adr_ort"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="!patient_final" class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="input-land">{{$t("land")}}</label>
                      <select
                        id="input-land"
                        name="land"
                        class="form-control"
                        v-model="adr_land"
                      >
                        <option value="">{{ $t("actions.bitte_waehlen") }}</option>
                        <option
                          v-for="(land) in laender"
                          :key="land.id"
                          :value="land.id"
                        >
                          {{ land.title }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div v-if="!patient_final" class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label
                        for="input-telefonnummer"
                        v-html="$t('telephone')"
                      ></label>
                      <div class="input-group">
                        <select class="form-control col-3 col-md-4 col-lg-3" :class="{
                            'is-invalid': !validTelephone && hasError,
                          }" v-model="phoneCode">
                          <option value="">{{ $t("actions.bitte_waehlen") }}</option>
                          <option v-for="code in phoneCodes" :key="code.alpha2" :value="code.code">{{code.flag}} {{ code.code.replace(/^00/, "+") }}</option>
                        </select>

                        <input
                          id="input-telefonnummer"
                          name="phone"
                          type="tel"
                          class="form-control"
                          v-model="telefonnummer"
                          :class="{
                            'is-invalid': !validTelephone && hasError,
                          }"
                        />
                      </div>
                      <div
                        v-if="!validTelephone && hasError"
                        class="invalid-feedback"
                      >
                        {{ $t("error.telephone_invalid") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for="input-mailadresse">{{
                        $t("mailadress")
                      }}</label>
                      <input
                        id="input-mailadresse"
                        name="email"
                        type="email"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            (!mailadresse || !validEmail) && hasError,
                        }"
                        v-model="mailadresse"
                      />
                      <div
                        v-if="!mailadresse && hasError"
                        class="invalid-feedback"
                      >
                        {{ $t("error.email") }}
                      </div>
                      <div
                        v-if="!validEmail && hasError"
                        class="invalid-feedback"
                      >
                        {{ $t("error.email_invalid") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="input-freitext">{{ $t("freitext") }}</label>
                      <textarea
                        id="input-freitext"
                        name="freitext"
                        type="text"
                        class="form-control"
                        v-model="freitext"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 form-check-label text-dark font-weight-bold">
                    {{ $t("label_benachrichtigungen") }}
                  </div>
                  <div class="col-12">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="input-benachrichtigungen" id="input-benachrichtigungen-ja" :value="true" v-model="benachrichtigungen">
                      <label class="form-check-label text-dark" for="input-benachrichtigungen-ja">{{ $t("actions.ja") }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="input-benachrichtigungen" id="input-benachrichtigungen-nein" :value="false" v-model="benachrichtigungen">
                      <label class="form-check-label text-dark" for="input-benachrichtigungen-nein">{{ $t("actions.nein") }}</label>
                    </div>
                  </div>
                  <div class="col-12 text-dark mb-2">
                    <label v-html="$t('hilfstext_benachrichtigungen')"></label>
                  </div>
                  <div class="col">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :class="{ 'is-invalid': !agb && hasError }"
                        v-model="agb"
                        id="input-agb"
                      />
                      <label
                        class="form-check-label text-dark font-weight-bold"
                        for="input-agb"
                        v-html="
                          $tc('read_agb', 1, {
                            agbUrl: agburl,
                            datenschutzUrl: datenschutzurl,
                          })
                        "
                      ></label>
                      <div v-if="!agb && hasError" class="invalid-feedback">
                        {{ $t("error.agb") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <stornierung-alert
                      v-if="stornierung"
                      :stornierung="stornierung"
                      class="mt-3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-none d-lg-block mb-3">
          <div class="row mt-3">
            <div class="col-md-6">
              <button
                class="btn btn-outline-secondary"
                @click="$store.dispatch('terminbuchungAbbrechen')"
              >
                {{ $t("actions.terminbuchung_abbrechen") }}
              </button>
            </div>
            <div class="col-md-6 text-right">
              <button
                class="btn btn-primary"
                :disabled="$store.getters.isLoading"
                @click="book"
              >
                {{ $t("actions.termin_buchen") }}
                <span v-if="callcenter" style="color: black"
                  ><br />(Buchung als CallCenter)</span
                ><font-awesome-icon
                  icon="spinner"
                  class="ml-2"
                  spin
                  v-if="$store.getters.isLoading"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 d-lg-none mb-3">
          <div class="row mt-3">
            <div class="col-12 text-right">
              <button
                class="btn btn-primary w-100"
                :disabled="$store.getters.isLoading"
                @click="book"
              >
                {{ $t("actions.termin_buchen") }}
                <span v-if="callcenter" style="color: black"
                  ><br />(Buchung als CallCenter)</span
                >
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonSwitch from "./ButtonSwitch.vue";
import TerminZusammenfassung from "./TerminZusammenfassung";
import { DateTime } from "luxon";
import cliniusLaender from "../static/land.clinius";
import cliniusChLaender from "../static/land.cliniusCh";
import phoneCodes from "../static/phone_codes";

import { de, en } from "vuejs-datepicker/dist/locale";
import _ from "lodash";

import {
  SET_ANREDE,
  SET_VORNAME,
  SET_NAME,
  SET_GEBURTSDATUM,
  SET_TELEFONNUMMER,
  SET_MAILADRESSE,
  SET_ADR_STRASSE,
  SET_ADR_STRASSENR,
  SET_ADR_PLZ,
  SET_ADR_ORT,
  SET_ADR_LAND,
  SET_BENACHRICHTIGUNGEN,
  SET_AGB,
  SET_SELECTED_TERMIN,
  SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN,
  SET_SELECTED_DAY,
  SET_SELECTED_ROW,
} from "@/store/mutations.type";
import { SET_FREITEXT } from "../store/mutations.type";
import StornierungAlert from "./StornierungAlert.vue";

// eslint-disable-next-line no-useless-escape
const mailRegex =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

// eslint-disable-next-line no-useless-escape
const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;

export default {
  name: "PatientendatenComponent",
  components: {
    ButtonSwitch,
    TerminZusammenfassung,
    StornierungAlert,
  },
  props: {
    isOtpPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasError: false,
      jahr: null,
      monat: null,
      tag: null,
      emailInvalid: false,
    };
  },
  watch: {
    jahr() {
      this.calcGeburtsdatum();
    },
    monat() {
      this.calcGeburtsdatum();
    },
    tag() {
      this.calcGeburtsdatum();
    },
    adr_land(newVal) {
      let country = this.laender.find((land) => land.id === newVal);
      console.log("Land geändert", newVal, country);
      if (country && country.short) {
        const pc = phoneCodes.find((p) => p.alpha2 == country.short);
        console.log("Ländervorwahl gefunden", pc);
        this.phoneCode = pc.code || "";
      }
    },
  },
  computed: {
    callcenter() {
      return this.$store.state.callcenter === true;
    },
    patient_final() {
      return this.$store.state.patient.patient_hash !== null;
    },
    showDateTextInput() {
      return this.isSafari && !this.isMobile;
    },
    datepickerLanguage() {
      if (this.$i18n.locale === "de") return de;
      else return en;
    },
    anzahlTage() {
      return this.isMobile ? 4 : 7;
    },
    proposal() {
      return this.$store.state.termin.selectedTermin;
    },
    terminart() {
      return this.$store.state.termin.behandlung;
    },
    startDate() {
      return this.$store.state.startDate;
    },
    behandlung() {
      return this.$store.state.termin.behandlung;
    },
    praxis() {
      return this.$store.state.termin.praxis;
    },
    behandler() {
      return this.$store.state.termin.behandler;
    },
    anrede: {
      get() {
        return this.$store.state.patient.anrede;
      },
      set(val) {
        this.$store.commit(`patient/${SET_ANREDE}`, val);
      },
    },
    vorname: {
      get() {
        return this.$store.state.patient.vorname;
      },
      set(val) {
        this.$store.commit(`patient/${SET_VORNAME}`, val);
      },
    },
    name: {
      get() {
        return this.$store.state.patient.name;
      },
      set(val) {
        this.$store.commit(`patient/${SET_NAME}`, val);
      },
    },
    geburtsdatum: {
      get() {
        return this.$store.state.patient.geburtsdatum;
      },
      set(val) {
        this.$store.commit(`patient/${SET_GEBURTSDATUM}`, val);
      },
    },
    telefonnummer: {
      get() {
        return this.$store.state.patient.telefonnummer;
      },
      set(val) {
        this.$store.commit(`patient/${SET_TELEFONNUMMER}`, val);
      },
    },
    phoneCode: {
      get() {
        // gib hier die ländervorwahl aus der Telefonnummer zurück, beachte dabei, dass diese ggf. mit + oder 00 beginnt
        // gehe die Phonecodes durch und finde den passenden Eintrag, gehe hierbei greedy vor, also den längsten match
        return this.telefonnummer
          ? phoneCodes.find((code) => {
              return (
                this.telefonnummer.startsWith(code.code) ||
                this.telefonnummer.startsWith(code.code.replace(/^00/, "+"))
              );
            })?.code || ""
          : "";
      },
      set(val) {
        if (this.telefonnummer) {
          // entferne die alte Ländervorwahl
          let newNumber = this.telefonnummer;
          phoneCodes.forEach((code) => {
            if (
              newNumber.startsWith(code.code) ||
              newNumber.startsWith(code.code.replace(/^00/, "+"))
            ) {
              newNumber = newNumber.substring(code.code.length);
            }
          });
          // entferne ggf. die führende Null
          if (newNumber.startsWith("0")) {
            newNumber = newNumber.substring(1);
          }
          // füge die neue Ländervorwahl hinzu
          this.telefonnummer = val + newNumber;
        } else {
          this.telefonnummer = val;
        }
      },
    },
    mailadresse: {
      get() {
        return this.$store.state.patient.mailadresse;
      },
      set(val) {
        this.$store.commit(`patient/${SET_MAILADRESSE}`, val);
      },
    },

    adr_strasse: {
      get() {
        return this.$store.state.patient.adr_strasse;
      },
      set(val) {
        this.$store.commit(`patient/${SET_ADR_STRASSE}`, val);
      },
    },
    adr_strassenr: {
      get() {
        return this.$store.state.patient.adr_strassenr;
      },
      set(val) {
        this.$store.commit(`patient/${SET_ADR_STRASSENR}`, val);
      },
    },
    adr_plz: {
      get() {
        return this.$store.state.patient.adr_plz;
      },
      set(val) {
        this.$store.commit(`patient/${SET_ADR_PLZ}`, val);
      },
    },
    adr_ort: {
      get() {
        return this.$store.state.patient.adr_ort;
      },
      set(val) {
        this.$store.commit(`patient/${SET_ADR_ORT}`, val);
      },
    },
    adr_land: {
      get() {
        return this.$store.state.patient.adr_land;
      },
      set(val) {
        this.$store.commit(`patient/${SET_ADR_LAND}`, val);
      },
    },

    freitext: {
      get() {
        return this.$store.state.patient.freitext;
      },
      set(val) {
        this.$store.commit(`patient/${SET_FREITEXT}`, val);
      },
    },
    benachrichtigungen: {
      get() {
        return this.$store.state.patient.benachrichtigungen;
      },
      set(val) {
        this.$store.commit(`patient/${SET_BENACHRICHTIGUNGEN}`, val);
      },
    },
    agb: {
      get() {
        return this.$store.state.patient.agb;
      },
      set(val) {
        this.$store.commit(`patient/${SET_AGB}`, val);
      },
    },
    laender() {
       if (
          process.env.VUE_APP_CLINIUS_CH &&
          process.env.VUE_APP_CLINIUS_CH === "1"
        ) {
          return cliniusChLaender.map((land) => ({
            id: land.id,
            title: land[this.$i18n.locale],
            short: land.short,
          }));
        } else {
          return cliniusLaender.map((land) => ({
            id: land.id,
            title: land[this.$i18n.locale],
            short: land.short,
          }));
        }
    },
    phoneCodes() {
      return phoneCodes;
    },
    validEmail() {
      if (!this.mailadresse) return true; // Wenn Keine Mail angegeben soll anderer Fehler kommen
      return this.mailadresse.match(mailRegex) && !this.emailInvalid;
    },
    validTelephone() {
      if (!this.telefonnummer) return false;
      if (!this.phoneCode || this.phoneCode === "") return false;
      //return (this.telefonnummer.length > 6);
      return this.telefonnummer.match(phoneRegex);
    },
    invalidGeburtstag() {
      if (!this.geburtsdatum) return false;
      let dateTime = DateTime.fromFormat(this.geburtsdatum, "yyyy-MM-dd");
      return !dateTime.isValid || dateTime.ts > DateTime.local().ts;
    },
    agburl() {
      return process.env.VUE_APP_AGB_URL;
    },
    datenschutzurl() {
      return process.env.VUE_APP_DATENSCHUTZ_URL;
    },
    stornierung() {
      return this.$store.state.termin?.selectedTermin?.stornierung;
    },
  },
  mounted() {
    if (this.isMobile || !this.isOtpPage) {
      const el = document.getElementById(this.appId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
    this.hasError = false;
  },
  methods: {
    book() {
      this.hasError =
        ((!this.anrede ||
          !this.name ||
          !this.vorname ||
          !this.geburtsdatum ||
          !this.mailadresse ||
          (!this.validEmail && !this.emailInvalid) ||
          !this.validTelephone ||
          this.invalidGeburtstag) &&
          !this.patient_final) ||
        !this.agb;

      if (!this.hasError) this.$emit("buchen", this.emailInvalid);
    },
    showEmailInvalid() {
      this.emailInvalid = true;
      this.hasError = true;
    },
    unselectTermin() {
      if (this.$store.state.termin.behandlerauswahlUebersprungen) {
        this.$store.commit(`termin/${SET_SELECTED_DAY}`, null);
        this.$store.commit(`termin/${SET_SELECTED_ROW}`, null);
        this.$store.commit(
          `termin/${SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN}`,
          false
        );
      }
      this.$store.commit(`termin/${SET_SELECTED_TERMIN}`, null);
    },
    showTerminBereitsVergeben() {
      this.$refs.terminBereitsVergebenAlert.show();
    },
    showSolvencyInvalid() {
      this.$refs.kreditunwuerdigAlert.show();
    },
    zurTerminwahl() {
      this.$store.commit(`termin/${SET_SELECTED_DAY}`, null);
      this.$store.commit(`termin/${SET_SELECTED_ROW}`, null);
      this.$store.commit(`termin/${SET_SELECTED_TERMIN}`, null);

      this.$store.dispatch("loadTermine", [
        this.startDate,
        this.anzahlTage,
        this.behandlung.id,
        this.praxis,
        this.behandler ? this.behandler.id : null,
      ]);
    },
    calcGeburtsdatum() {
      this.geburtsdatum =
        this.tag && this.monat && this.jahr
          ? `${this.jahr}-${_.padStart(`${this.monat}`, 2, "0")}-${_.padStart(
              `${this.tag}`,
              2,
              "0"
            )}`
          : null;
    },
  },
};
</script>

<style lang="css">
.formatSelect {
  height: calc(1.5em + 0.75rem + 2px) !important;
  padding: 0.15rem 0.15rem 0.175rem 0.15rem !important;
  padding-left: 0.15rem !important;
  font-size: 1rem !important;
}
.formatSelect .vs__dropdown-toggle {
  border: none !important;
}
</style>
